module.exports = __webpack_public_path__ + "static/media/Otchet_o_provedenii_SOUT_ANO_Mosprom.8006d57e.pdf";